import * as Yup from "yup";
import dayjs from "dayjs";

import {
    validationSchema as adjustmentValidationSchema,
    validationRowSchema as adjustmentValidationRowSchema,
    initialValues as adjustmentInitialValues,
    initialRowValues as adjustmentInitialRowValues
} from "./adjustmentSchema";

export const validateRowSchema = Yup.object().shape({
    itemId: Yup
        .string(),
    // .required("Required"),
    code: Yup
        .string()
        .required("Required"),
    name: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    qty: Yup
        .number("")
        // .positive("Invalid")
        .required("Required"),
    price: Yup
        .number("")
        // .positive("Invalid")
        .required("Required")
})

export const validationSchema = Yup.object({
    locationId: Yup
        .string()
        .required("Required"),
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    userId: Yup
        .string()
        .required("Required"),
    shippingBranchId: Yup
        .string()
        .required("Required"),
    billingBranchId: Yup
        .string()
        .required("Required"),
    codEnabled: Yup
        .bool()
        .required("Required"),
    distribution: Yup.lazy((val) => {

        let enabled = val?.enabled ? val.enabled : 0

        let enabledSchema = Yup
            .bool()
            .required("Required")

        if (enabled) {
            return Yup.object().shape({
                enabled: enabledSchema,
                locationId:
                    Yup
                        .string()
                        .required("Required"),
            })
        }

        return Yup.object().shape({
            enabled: enabledSchema,
        })

    }),
    // distributionEnabled: Yup
    //     .bool()
    //     .required("Required"),
    // distributionLocationId: Yup
    //     .string()
    //     .required("Required"),
    codRequiredAmount: Yup
        .number()
        .typeError("Number Only")
        .required("Required"),
    codCollectedAmount: Yup
        .number()
        .typeError("Number Only")
        .required("Required"),
    rows: Yup.array().of(validateRowSchema),

    adjustments: adjustmentValidationSchema

})

export const initialRowValues = {
    docItemId: "",
    itemId: "",
    name: "",
    code: "",
    description: "",
    qty: "",
    uomName: "",
    uomId: "",
    price: "",
    subtotal: "0.00",
}

export const initialValues = {
    locationId: "",
    locationName: "",
    documentNumber: "",
    documentDate: dayjs(),
    remark: "",
    userId: "",
    username: "",
    shippingBranchId: "",
    billingBranchId: "",

    rows: [initialRowValues],

    alternativeNo: "",
    soId: [],
    containerId: "",
    trackingNo: "",

    codEnabled: false,
    codRequiredAmount: 0.00,
    codCollectedAmount: 0.00,
    codCollectionRemark: "",

    distribution: {
        enabled: false,
        locationId: ""
    },

    totalamount: "0.00",

}